import { render, staticRenderFns } from "./RecommendationSliders.vue?vue&type=template&id=26d21d8d&scoped=true"
import script from "./RecommendationSliders.vue?vue&type=script&lang=js"
export * from "./RecommendationSliders.vue?vue&type=script&lang=js"
import style0 from "./RecommendationSliders.vue?vue&type=style&index=0&id=26d21d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d21d8d",
  null
  
)

export default component.exports